import React, { Component } from 'react';
import { Route, HashRouter as Router, Switch, Redirect } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import utils from '@/utils/auth';
import zhCN from 'antd/es/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import './App.css';
import LayoutPage from './pages/index.jsx';
import LoginPage from './pages/login/index.jsx';
moment.locale('zh-cn');

export default class App extends Component {

  render() {
    return (
      <div id='app'>
        <ConfigProvider locale={zhCN}>
          <Router>
            <Switch>
              <Route path='/login' component={LoginPage}/>
              <Route path='/layout' component={LayoutPage}/>
              <Route path='*' exact render={() => {
                if (utils.isLoginStatus()) return <Redirect to='/layout' />
                  return <Redirect to='/login' />
              }}/>
            </Switch>
          </Router>
        </ConfigProvider>
      </div>
    );
  }
}
